import { get, post } from './../Config/config';

export const DynamicdropdownsAPI = {
    get: (data) => get(`/crm-status/list`, { params: data }),
    getCountryList: (data) => get(`/countries?`, { params: data }),
    getAgeList: (data) => get(`/age-ranges?`, { params: data }),
    getProfessinalList: (data) => get(`/professions`, { params: data }),

}  
